import Vue from 'vue';
export const eventBus = new Vue();

export const $emitGlobalEvent = (eventName, payload) => {
    eventBus.$emit(eventName, payload);
}

export const $listenForGlobalEvent = (eventName, callback) => {
    eventBus.$on(eventName, callback);
}
